import React from 'react';
import Table from './table/Table';
import {observer, inject} from 'mobx-react'
import {cdn} from '../helpers/cdn'

const metadata = {
    icon: cdn('icons/twitch.svg'),
    title: 'Top Twitch Emotes',
    colorPrimary: '#9200ff',
    colorSecondary: '#f9f1ff',
};

@inject('store') @observer
class TwitchTable extends React.Component {

    render() {
        const {store} = this.props;
        const {items, status} = store.twitchEmotes;
        return (
            <Table tableMetadata={metadata} status={status} data={items} tableType="twitchEmotes"/>
        );
    }
}

export default TwitchTable;



// WEBPACK FOOTER //
// ./src/app/components/TwitchTable.js